import React from "react";

import { UseCases } from "@planzone/core";
import { Props } from "./types";
import { Status } from "./status";
import { Safeguard } from "@scenes/safeguard";

function TaskStatus(props: Props) {
  return (
    <Safeguard
      useCases={[UseCases.editTask]}
      context={{ project: props.project }}
    >
      {({ canEditTask }) => (
        <Status
          status={props.status}
          project={props.project}
          isReduced={props.isReduced}
          canEditStatus={canEditTask && !props.project.isTemplate}
          selectStatus={(status) => {
            props.selectStatus && props.selectStatus(status);
          }}
        />
      )}
    </Safeguard>
  );
}

export { TaskStatus };
